import React from 'react'
import ProfileOverview from 'src/app/ProfileOverview/ProfileOverview'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { profileOverviewRouteProps } from 'src/navigation/routeProps'

const ProfileOverviewAppRoute: AppRoute = {
  id: AppLocation.ProfileOverview,
  routeProps: profileOverviewRouteProps,
  component: <ProfileOverview />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Settings },
}

export default ProfileOverviewAppRoute
